import React, { useState, useEffect } from 'react';
import { Reorder } from "framer-motion";
import { Button, Card, CardContent, Chip, Divider } from '@mui/material';
import { HiCog, HiDotsVertical } from "react-icons/hi";

import SideBar from "../../SideBar";
import SnackBarMessage from '../../components/SnackBarMessage';
import './Settings.css';
import { getRequests } from '../../Helper/adminModuleApi';
import { getDocumentsPriority, updateDocumentPriority } from '../../Helper/adminModuleApi';
import RequestDocumentPopup from './RequestDocumentPopup'; 

function Settings() {
    const [items, setItems] = useState([]);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [requests, setRequests] = useState([]);
    const [showPopup, setShowPopup] = useState(false);

    // New state for the document request fields
    const [documentName, setDocumentName] = useState('');
    const [reason, setReason] = useState('');
    const [additionalField, setAdditionalField] = useState(''); // Example additional field

    useEffect(() => {
        const fetchData = async () => {
            await getPriorityData();
            await fetchRequests();  // Fetch requests on initial load
        };
        fetchData();
    }, []);

    const addNewRequest = (newRequest) => {
        setRequests((prevRequests) => [...prevRequests, newRequest]);
    };

    const getPriorityData = async () => {
        const response = await getDocumentsPriority();
        if (response?.data && response?.data.status === 200) {
            const sortedItems = response?.data.body.sort((a, b) => a.priority - b.priority);
            setItems(sortedItems);
        }
    }

    const handleReorder = (newItems) => {
        setItems(newItems);
        newItems.forEach((item, index) => {
            item.priority = index + 1; // Reassign priorities based on new order
        });
    };

    const onSavePreferences = async () => {
        const res = await updateDocumentPriority(items);
        setSnackBarMessage(res.data.message);
        setIsSnackbarOpen(true);
    };

    const handleRequestNewDocument = async () => {
        setSnackBarMessage("Document request submitted successfully");
        setIsSnackbarOpen(true);
        await fetchRequests();
    };


    const fetchRequests = async () => {
        setIsLoading(true);
        try {
            const companyUuid = JSON.parse(localStorage.getItem('userDetails')).company_uuid;
            const response = await getRequests(companyUuid);
            setRequests(response?.data?.body);
            const updatedRows = response?.data?.body.map((request, index) => ({
                id: index,
                documentName: request.document_name,
                reason: request.reason,
                status: request.status,
                ...request
            }));
            setRows(updatedRows);
        } catch (error) {
            console.error("An error occurred while fetching requests data.", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getStatusClassName = (status) => {
        console.log("Status:", status.toLowerCase()); 
        switch (status.toLowerCase()) {
            case 'requested':
                return 'fl-r status-chips bg-nd-requested';
            case 'in-progress':
                return 'fl-r status-chips bg-nd-in-progress';
            case 'approved':
                return 'fl-r status-chips bg-nd-accepted';
            case 'rejected':
                return 'fl-r status-chips bg-nd-rejected';
            default:
                console.log('Returning default class');
                return 'fl-r status-chips';
        }
    };


    useEffect(() => {
        fetchRequests(); 
    }, []);

    return (
        <div style={{ height: "100vh", display: "flex" }}>
            <SideBar />
            <div className='container-fluid d-flex flex-column'>
                <header className='p-3'>
                    <h2 className="m-0">
                        <HiCog className='fs-xxl theme-color' /> Settings
                    </h2>
                    <Divider className='bg-grey mt-2' />
                </header>

                <div className='scrollable-container-new-doc-req' style={{ paddingBottom: '20px' }}>
                    <div className="container-fluid mt-3 px-5">
                        {/* Document Priority Section */}
                        <div className="row">
                            <div className="col-12 d-flex justify-content-start align-items-center mb-3">
                                <h5>Documents Priority</h5>
                            </div>
                            <div className="col-6">
                                <Reorder.Group axis="y" values={items} onReorder={handleReorder} className="pl-0 reorder-group">
                                    {items.map((item) => (
                                        <Reorder.Item key={item.preference_id} value={item} className="reorder-item mb-3">
                                            <HiDotsVertical className="drag-handle" />
                                            <span>{item.priority}. {item.document_name}</span>
                                        </Reorder.Item>
                                    ))}
                                </Reorder.Group>
                                <Button className='confirmation-buttons theme-bg w-100' variant="contained" color="primary" onClick={onSavePreferences}>
                                    <span className='text-trans-none'>Save</span>
                                </Button>
                                <SnackBarMessage
                                    isSnackbarOpen={isSnackbarOpen}
                                    snackBarMessage={snackBarMessage}
                                    setIsSnackbarOpen={setIsSnackbarOpen}
                                />
                            </div>
                        </div>

                        {/* <div className='col-12 d-flex flex-column' style={{ paddingTop: '20px', paddingBottom:'80px'}}>
                            <Divider className='bg-grey' />
                            <div className="d-flex justify-content-between align-items-center" style={{ paddingTop: '20px', paddingBottom:'20px' }}>
                                <h5>Document Request Status</h5>
                                <Button
                                    variant="contained"
                                    className="theme-bg btn-sm"
                                    color="primary"
                                    onClick={() => setIsDialogOpen(true)} 
                                >
                                    <span className='text-trans-none'>Request New Document</span>
                                </Button>
                            </div>

                            <div>
                                {rows.length === 0 ? (
                                    <div className='div-center'>
                                        <p>No requests to display</p>
                                    </div>
                                ) : (
                                    <div className='row'>
                                        {rows.map((request) => (
                                            <div className='col-6 px-3' key={request.id}>
                                                <Card className='card-box-shadow req-card-box-shadow mb-2'>
                                                    <CardContent className='p-2'>
                                                        <div>
                                                            <strong>{request.documentName}</strong>
                                                            <Chip className={getStatusClassName(request.status)} label={request.status} />
                                                        </div>
                                                        <div className='requests-font-size'>
                                                            <span>{request.reason}</span>
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div> */}
                    </div>
                </div>
                <RequestDocumentPopup
                    isDialogOpen={isDialogOpen}
                    handleClose={() => setIsDialogOpen(false)}
                    handleRequestNewDocument={handleRequestNewDocument}
                    onRequestAdded={addNewRequest}
                />
            </div>
        </div>
    );
}

export default Settings;
